/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completeScenario} from '../api'

export const useMutationCompleteScenario = createReactQueryMutationHook('completeScenario', completeScenario)
